import { useEffect, useState } from 'react'

import { APP_SESSION } from '@zet/constants'
import { checkForUpdateAsync, fetchUpdateAsync, useUpdates } from 'expo-updates'

const UpdatesModule = {
  useUpdates: () => {
    const [isChecked, setIsChecked] = useState(true)
    // const updateSkippedRef = useRef(false)

    useEffect(() => {
      // TODO: If mandatory ota update then wait for download and reload
      // const timeout = setTimeout(() => {
      //   updateSkippedRef.current = true
      //   setIsChecked(true)
      // }, 4000)

      if (__DEV__) {
        // setIsChecked(true)
        return
      }

      if (APP_SESSION.getReloadType === 'NORMAL') {
        const checkStartTime = Date.now()
        console.log('Updates Module Check Started at :: ', checkStartTime)
        checkForUpdateAsync()
          .then((response) => {
            const checkEndTime = Date.now()
            console.log('Updates Module Check Ended at :: ', checkEndTime)
            console.log(
              'Updates Module Check Difference :: ',
              checkEndTime - checkStartTime,
            )
            // setIsChecked(true)
            if (response.isAvailable) {
              // setIsChecked(true)
              const fetchStartTime = Date.now()
              console.log('Updates Module Fetch Started at :: ', fetchStartTime)
              fetchUpdateAsync()
              const fetchEndTime = Date.now()
              console.log('Updates Module Fetch Started at :: ', fetchEndTime)
              console.log(
                'Updates Module Fetch Difference :: ',
                fetchEndTime - fetchStartTime,
              )
            } else {
              // setIsChecked(true)
            }
          })
          .catch((error) => {
            // setIsChecked(true)
          })
      } else {
        // setIsChecked(true)
      }
      APP_SESSION.setReloadType('NORMAL')
    }, [])

    return { isChecked }
  },
  useUpdatesAvailable: () => {
    const { isUpdateAvailable, isUpdatePending } = useUpdates()

    return { isReloadable: isUpdateAvailable && isUpdatePending }
  },
}

export { UpdatesModule }
